var _circle, _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiniVolasLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#D8D8D8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1211_12383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.58203 9.99609H12.0034L21.6859 22.1242L20.7974 24.003H13.2087L6.58203 9.99609Z",
    fill: "url(#paint0_linear_1211_12383)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4134 16.3627H19.3038L20.3207 15.0907H25.0153L25.6171 13.8171H21.336L22.3529 12.5434H26.2206L27.4225 9.99609H21.9945L12.3203 22.1176L13.2105 24.003H23.1848L21.6877 22.1242L24.4134 16.3627Z",
    fill: "url(#paint1_linear_1211_12383)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1211_12383",
    x1: 6.79542,
    y1: 9.82438,
    x2: 19.2753,
    y2: 25.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF2431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#73161D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1211_12383",
    x1: 17.555,
    y1: 13.5904,
    x2: 24.8769,
    y2: 22.6327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF2431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC202C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1211_12383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8387,
    height: 20.8387,
    fill: "white",
    transform: "translate(6.58203 6.58008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniVolasLogo);
export default __webpack_public_path__ + "static/media/mini-volas-logo.55f7744f83bf652085892ad3d6b35ff9.svg";
export { ForwardRef as ReactComponent };